module.exports = __webpack_public_path__ + "r-v3/img/ml_03_00.d333220b.jpg";